import { render, staticRenderFns } from "./bf-dialog.vue?vue&type=template&id=6bc94492&scoped=true&lang=pug&"
import script from "./bf-dialog.vue?vue&type=script&lang=js&"
export * from "./bf-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bf-dialog.vue?vue&type=style&index=0&id=6bc94492&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc94492",
  null
  
)

export default component.exports